export enum AbstractContainerJobType {
    Move = 1,
    Outbound,
    Inbound,
    Import,
    Coastal,
    Rail,
    Sea,
    Intermodal,
}